module.exports = __webpack_public_path__ + "img/25.81c9df22.jpg";